import React from 'react';
import PropTypes from 'prop-types';
import { I18nextProvider } from 'react-i18next';
import i18next from 'i18next';

import GlobalEn from './en/global.json';
import GlobalEs from './es/global.json';

const locale = navigator.languages[1];

i18next.init({
  interpolation: { escapeValue: false },
  lng: locale === 'es' ? 'es' : 'en',
  resources: {
    es: {
      global: GlobalEs,
    },
    en: {
      global: GlobalEn,
    },
  },
});

const TransProvider = ({ children }) => (
  <I18nextProvider i18n={i18next}>{children}</I18nextProvider>
);

TransProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export default TransProvider;
